<template>
  <div id="berth-insert-data">
    <berth-form
      mode="insert"
    >
    </berth-form>
  </div>
</template>

<script>

import BerthForm from "./BerthForm";

export default {
  components: {
    BerthForm,
  },
  data() {
    return {
    }
  },
  created() {
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
</style>
